module.exports = __webpack_public_path__ + "static/18-c33150c13d6aba990d36c8cf141b01d4.jpg";